import { render, staticRenderFns } from "./image.vue?vue&type=template&id=3bd3666a&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&id=3bd3666a&lang=scss&scoped=true&"
import style1 from "./image.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd3666a",
  null
  
)

export default component.exports